import AttendApplicationApproval from './AttendApplicationApproval'

export default AttendApplicationApproval;
